import { useState, useEffect } from "react";

/**
 * 離線提示橫幅
 * - 偵測網路狀態，斷線時顯示在畫面頂部
 * - 恢復連線後自動消失（淡出）
 */
export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [visible, setVisible] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setVisible(true);
    };
    const handleOnline = () => {
      // 恢復後先保留橫幅 2 秒，再淡出
      setIsOffline(false);
      const timer = setTimeout(() => setVisible(false), 2000);
      return () => clearTimeout(timer);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`
        fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2
        px-4 py-2 text-sm font-medium transition-all duration-500
        ${isOffline
          ? "bg-amber-500 text-white opacity-100 translate-y-0"
          : "bg-emerald-500 text-white opacity-0 -translate-y-full"
        }
      `}
      role="status"
      aria-live="polite"
    >
      {isOffline ? (
        <>
          <i className="ri-wifi-off-line text-base" />
          <span>目前處於離線狀態，顯示的是已快取的資料</span>
        </>
      ) : (
        <>
          <i className="ri-wifi-line text-base" />
          <span>網路已恢復連線</span>
        </>
      )}
    </div>
  );
}
